function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.41,180c2.27-23.46,7.7-45.67-1.9-68.23C402.89,70.37,349.74,48.39,308.44,68,287.32,78,269.26,92.63,246,98,183.22,112.49,86.32,35.29,52.15,125.17c-11.73,30.84-7,71.48,14.21,97.26,6.81,8.27,15.13,15.47,20.17,24.93C100.32,273.25,80.8,301.7,72,325.85c-20.9,57.07,57.9,88.65,100.67,94.47C243.37,430,301.69,349,372,382c49,23,92-33,83-89-5.89-36.66-35.71-71.75-32.92-109.11C422.18,182.6,422.29,181.31,422.41,180Z",
    style: {
      fill: "#FAA700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.41,180c2.27-23.46,7.7-45.67-1.9-68.23C402.89,70.37,349.74,48.39,308.44,68,287.32,78,269.26,92.63,246,98,183.22,112.49,86.32,35.29,52.15,125.17c-11.73,30.84-7,71.48,14.21,97.26,6.81,8.27,15.13,15.47,20.17,24.93C100.32,273.25,80.8,301.7,72,325.85c-20.9,57.07,57.9,88.65,100.67,94.47C243.37,430,301.69,349,372,382c49,23,92-33,83-89-5.89-36.66-35.71-71.75-32.92-109.11C422.18,182.6,422.29,181.31,422.41,180Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.77,
    cy: 160.73,
    r: 34.53,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.2,
    cy: 157.3,
    r: 34.53,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.2,
    cy: 157.3,
    r: 31.1,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.55,133.92s-3.43-8.58-9.43-14.58-30.46-9.87-30.46-9.87a89.68,89.68,0,0,1,10.73,12.44c5.57,7.72,24,25.31,24,25.31s-9-7.72-17.16-8.58-28.74,3.43-30,3.43,7.72,3.43,14.16,6.43,31.31,5.58,31.31,5.58-10.72,3-18,5.58S40.52,181.1,40.52,181.1s9.44-8.58,17.59-10.72,19.73-6,19.73-6-7.29,8.15-9,13.73-.43,18.44-.43,18.44,3.86-12,8.58-16.73S86.84,167,86.84,167a118,118,0,0,1,6.44,12c3.43,7.29,5.57,18,5.57,18s5.58-12,5.15-18-6.86-16.73-6.86-16.73,4.29-3,10.72-.43,17.59,13.3,17.59,13.3-2.58-14.16-6.87-19.73-22.73-7.3-22.73-7.3,10.3-6,16.73-7.29,15,1.72,15,1.72-9.86-13.73-17.58-14.59S90.7,139.07,90.7,139.07l3.44-17.16c.85-4.29-.86-15-.86-15s-4.72,2.57-10.3,10.72A21.36,21.36,0,0,0,79.55,133.92Z",
    style: {
      fill: "#FAA700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.55,133.92s-3.43-8.58-9.43-14.58-30.46-9.87-30.46-9.87a89.68,89.68,0,0,1,10.73,12.44c5.57,7.72,24,25.31,24,25.31s-9-7.72-17.16-8.58-28.74,3.43-30,3.43,7.72,3.43,14.16,6.43,31.31,5.58,31.31,5.58-10.72,3-18,5.58S40.52,181.1,40.52,181.1s9.44-8.58,17.59-10.72,19.73-6,19.73-6-7.29,8.15-9,13.73-.43,18.44-.43,18.44,3.86-12,8.58-16.73S86.84,167,86.84,167a118,118,0,0,1,6.44,12c3.43,7.29,5.57,18,5.57,18s5.58-12,5.15-18-6.86-16.73-6.86-16.73,4.29-3,10.72-.43,17.59,13.3,17.59,13.3-2.58-14.16-6.87-19.73-22.73-7.3-22.73-7.3,10.3-6,16.73-7.29,15,1.72,15,1.72-9.86-13.73-17.58-14.59S90.7,139.07,90.7,139.07l3.44-17.16c.85-4.29-.86-15-.86-15s-4.72,2.57-10.3,10.72A21.36,21.36,0,0,0,79.55,133.92Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,120.86c.3-1.23.63-2.46,1-3.67",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.35,120.86c4,2.93,9,7,11.62,10.49,4.72,6.43,14.16,20.16,14.16,20.16A127.55,127.55,0,0,1,87.31,124",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.39,116.76s1.25.8,3.12,2.09",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13,151.51s16.3-16.3,23.16-17.59,12.87,3.86,12.87,3.86",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,165.14c-4,2.52-4.33,4-4.33,4",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.73,166.52s-2.57-6.44-11.58-9.44S86,153.65,86,153.65s-19.85,6.5-27.11,9.89",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,151.2c4.8,1.4,8.67,2.45,8.67,2.45",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.11,143.58c4.66.28,10.66.92,14,2.35,2.72,1.17,8.08,2.86,13.14,4.37",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.52,143.36s1.57,0,3.88.09",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.13,156.22s-12,18-12.87,22.31a43.68,43.68,0,0,0-.86,7.72",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,161.89c2.31,3,5.08,7,6.24,10.2a70.38,70.38,0,0,1,3,12",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.84,157.51s1,1.06,2.29,2.69",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,137.62s-2.21-9-.84-17.35,19-25.78,19-25.78a90.2,90.2,0,0,0-1.45,16.36c0,9.52-4.75,34.56-4.75,34.56s2.81-11.52,8.93-17,25.35-14,26.39-14.73-4.27,7.29-7.74,13.49S91.44,150,91.44,150s10.46-3.82,17.88-6,24,9.16,24,9.16-12.67-1.46-20.54,1.55-19.53,6.63-19.53,6.63,10.68,2.37,15.32,5.9S119.69,182,119.69,182s-10.14-7.51-16.73-8.59-15.52-4.69-15.52-4.69a120.64,120.64,0,0,0,1.78,13.5c1.47,7.93,6,17.89,6,17.89s-11.53-6.5-14.69-11.63-4.18-17.59-4.18-17.59-5.24.06-9,5.9-6.53,21.06-6.53,21.06-6.16-13-5.93-20,14.21-19.18,14.21-19.18-11.86,1.13-17.84,3.83-11.2,10.15-11.2,10.15,0-16.9,5.78-22.1,22.19-2.2,22.19-2.2l-12.8-11.93c-3.2-3-8.06-12.7-8.06-12.7s5.34-.66,14.62,2.71A21.31,21.31,0,0,1,74.1,137.62Z",
    style: {
      fill: "#FAA700"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.62,131.94c-1-.83-1.94-1.63-2.94-2.41",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.89,115.23c-1.55,4.72-3.28,10.93-3.32,15.29-.08,8,.26,24.63.26,24.63A127.12,127.12,0,0,0,62,134.09",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,108.42s-.56,1.38-1.32,3.51",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,155.15s-22.75-3.73-29.07-.77S42.56,165,42.56,165",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45,149.23c4.69-.26,5.81.69,5.81.69",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.67,188.11s-1.66-6.73,3.9-14.42S80.39,157.4,80.39,157.4s19.91-6.31,27.78-7.78",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,150.35c-3.08,3.93-5.6,7.05-5.6,7.05",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.09,126.54c-3.62,3-8.12,7-10,10.07-1.53,2.54-4.9,7-8.13,11.21",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.31,122.51s-1.27.92-3.1,2.34",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.58,159s20.27,7.62,23.46,10.61a43.42,43.42,0,0,1,5.2,5.77",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55,166.7c-.14,3.78-.07,8.63.88,11.93A69.72,69.72,0,0,0,87,190.14",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.94,161s-.16,1.42-.28,3.52",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.83,183.43H367.5a10.67,10.67,0,0,1,10.67,10.67v147a11.67,11.67,0,0,1-11.67,11.67H141.83a11.67,11.67,0,0,1-11.67-11.67v-147a10.67,10.67,0,0,1,10.67-10.67Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.83,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.6,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.76,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.66,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.02,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.99,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.17,
    y: 241.6,
    width: 24.56,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.23,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.17,
    y: 256.67,
    width: 17.23,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.16,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.7,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.33,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.5,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.96,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.49,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.83,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.99,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.35,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.62,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.6,
    y: 256.67,
    width: 19.23,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.16,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.17,
    y: 211.47,
    width: 13.33,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.33,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.49,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.56,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.09,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.29,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.82,
    y: 211.47,
    width: 13.06,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.66,
    y: 200.1,
    width: 13.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.77,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.77,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.6,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.43,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.27,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.93,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.1,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.43,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.27,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.33,
    y: 200.1,
    width: 11.51,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.17,
    y: 200.1,
    width: 12.96,
    height: 9.17,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.17,
    y: 271.73,
    width: 220.67,
    height: 13.37,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.88,
    y: 211.47,
    width: 21.95,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.93,
    y: 241.6,
    width: 11.9,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.27 239.3 349.06 239.3 349.06 226.54 336.1 226.54 336.1 239.3 333.9 239.3 333.9 226.54 320.94 226.54 320.94 239.3 318.73 239.3 318.73 226.54 305.77 226.54 305.77 239.3 303.56 239.3 303.56 226.54 290.6 226.54 290.6 239.3 288.4 239.3 288.4 226.54 275.44 226.54 275.44 239.3 273.23 239.3 273.23 226.54 260.27 226.54 260.27 239.3 258.06 239.3 258.06 226.54 245.1 226.54 245.1 239.3 242.9 239.3 242.9 226.54 229.94 226.54 229.94 239.3 227.73 239.3 227.73 226.54 214.77 226.54 214.77 239.3 212.56 239.3 212.56 226.54 199.6 226.54 199.6 239.3 197.4 239.3 197.4 226.54 184.44 226.54 184.44 239.3 182.23 239.3 182.23 226.54 169.27 226.54 169.27 239.3 167.06 239.3 167.06 226.54 146.17 226.54 146.17 239.4 366.83 239.4 366.83 226.54 351.27 226.54 351.27 239.3",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.6,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.1,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.27,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.43,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.1,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.77,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.93,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.77,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.6,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.93,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.27,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.43,
    y: 256.67,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.93,
    y: 241.6,
    width: 12.96,
    height: 12.86,
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.33,91.43H114.67a8.88,8.88,0,0,0-8.57,11.18l20.3,75.58a8.88,8.88,0,0,0,8.57,6.58h28.34V190H345v-5.2h27a8.88,8.88,0,0,0,8.57-6.58l20.3-75.58A8.88,8.88,0,0,0,392.33,91.43Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.93 178.1 146.07 178.1 124.58 100.77 382.41 100.77 360.93 178.1",
    style: {
      fill: "#FAA700",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,144.16v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.05,144.16v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.77,144.16v1H166v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.48,144.16v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,144.16v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.92,144.16v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.63,144.16v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,149.43l-4.18-11.14h1l4.18,11.14Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.23,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.67,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.38,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.36,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.79,127.94v1H189v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.51,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.22,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.66,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.63,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.35,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.07,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.76,127.94v1H238v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.48,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.22,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.94,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.37,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.09,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.06,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.78,127.94v1H292v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.47,127.94v1h-3.79v-1Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.45,127.94v1h-3.8v-1Z",
    style: {
      fill: "#2e353a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "379.69 292.29 368.99 333.57 379.11 336.54 379.69 292.29",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.49,248.66a8.55,8.55,0,0,1-1.23-6.28c.55-4.07,5.46-5,5.46-5s1.07-.81,5,.68,34.32,5.61,53.74,8.24,25.71.93,25.44,7.6-17.31,66.53-17.57,68.41S384.49,248.66,384.49,248.66Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.51,
    y: 253.75,
    width: 82.44,
    height: 98.27,
    transform: "translate(44.48 -53.5) rotate(7.72)",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.99,
    y1: 279.16,
    x2: 455.74,
    y2: 279.81,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.24,
    y1: 275.13,
    x2: 447.23,
    y2: 278.66,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.74,
    y1: 270.86,
    x2: 417.48,
    y2: 274.62,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443.55,
    y1: 286.97,
    x2: 454.57,
    y2: 288.47,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.57,
    y1: 279.52,
    x2: 432.28,
    y2: 285.44,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.75,
    y1: 291.34,
    x2: 453.4,
    y2: 297.12,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 387.39,
    y1: 288.17,
    x2: 406.36,
    y2: 290.75,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.92,
    y1: 302.08,
    x2: 452.22,
    y2: 305.78,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.75,
    y1: 298.93,
    x2: 421.79,
    y2: 301.65,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.22,
    y1: 296.83,
    x2: 398.3,
    y2: 298.47,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.28,
    y1: 313.11,
    x2: 451.05,
    y2: 314.43,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.05,
    y1: 305.49,
    x2: 434.71,
    y2: 312.22,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.26,
    y1: 319.34,
    x2: 449.88,
    y2: 323.09,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.87,
    y1: 314.14,
    x2: 417.56,
    y2: 318.71,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.79,
    y1: 329.32,
    x2: 448.7,
    y2: 331.74,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 394.47,
    y1: 324.39,
    x2: 426.41,
    y2: 328.72,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.7,
    y1: 322.8,
    x2: 390.71,
    y2: 323.88,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.18,259.74s1.4-13.58,6.4-8.12",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.48 364.35 438.39 372.98 433.36 365.88 413.17 297.97 418.29 296.44 438.48 364.35",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.37,
    y: 295.74,
    width: 2.91,
    height: 70.85,
    transform: "matrix(0.96, -0.28, 0.28, 0.96, -76.71, 135.07)",
    style: {
      fill: "#FAA700",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.48 364.37 433.37 365.89 438.39 372.98 438.48 364.37",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.88 369.43 438.39 372.98 438.44 368.67 435.88 369.43",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.47,289.6h0a2.68,2.68,0,0,0-1.8,3.32l1.5,5.05,5.12-1.52-1.5-5.05A2.68,2.68,0,0,0,413.47,289.6Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.47,289.6h0a2.68,2.68,0,0,0-1.8,3.32l.72,2.41,5.11-1.52-.71-2.41A2.68,2.68,0,0,0,413.47,289.6Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.65,249.49c-.64.9-1.27,1.84-1.9,2.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.11,237.45a72.17,72.17,0,0,0-7.71,8.37",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,242.76a106.63,106.63,0,0,0-7.41,12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.29,264.75c-.63.9-1.27,1.84-1.9,2.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.75,252.71a72.71,72.71,0,0,0-7.7,8.37",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.41,258A108.21,108.21,0,0,0,223,270.06",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.11,240c-.91-.62-1.87-1.24-2.86-1.86",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,250.28a73.41,73.41,0,0,0-8.49-7.57",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.83,239a108.34,108.34,0,0,0-12.16-7.23",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,302c-.52,3.76-1.3,9-2.08,12.11",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.83,297.43s-.08.71-.23,1.86",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5,308.1a84.55,84.55,0,0,1-4,10.67",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.5,313.43s.67,8.67,5.33,13.34",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.83,322.1s2,6,6,8.67",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,368.44s4.44-3.57,4.44-34.26,5.11-53.11,11.41-62.94,12.19-13.77,14.95-13.77.78,3.54-3.15,8.65-7.47,7.87-9.05,14.17-1.57,14.16.4,13.37,5.11-16.52,7.86-22.42,9.45-13.38,13.38-16.92,12.59-14.16,16.52-11.41,1.58,6.69-.78,8.26-11.81,11-16.13,16.92-7.08,20.85-4.72,21.24,9.44-21.63,13.37-26.35,19.67-17.71,23.21-18.1,3.94,5.11.79,7.87-13.77,14.55-17.31,21.63-5.12,20.07-2,16.92,8.26-16.13,12.59-20.46,17.31-18.09,20.46-16.52,2.36,5.51-.39,8.26-13.38,17.71-16.13,25.57-5.91,29.9-4.33,26.76,6.69-19.28,9.44-26,8.26-9.83,9.05-6.69-.79,4.72-2.76,11.81-2,26-7.86,36.58-29.38,33.22-32.52,41.08a107.12,107.12,0,0,1-8.12,15.6",
    style: {
      fill: "#FAA700",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.55,371.1S359,364.87,359,334.18s-5.12-53.11-11.41-62.94-12.2-13.77-14.95-13.77-.79,3.54,3.15,8.65,7.47,7.87,9,14.17,1.58,14.16-.39,13.37-5.11-16.52-7.87-22.42-9.44-13.38-13.37-16.92-12.59-14.16-16.53-11.41-1.57,6.69.79,8.26,11.8,11,16.13,16.92,7.08,20.85,4.72,21.24S318.86,267.7,314.93,263s-19.68-17.71-23.22-18.1-3.93,5.11-.78,7.87,13.77,14.55,17.31,21.63,5.11,20.07,2,16.92-8.26-16.13-12.58-20.46-17.31-18.09-20.46-16.52-2.36,5.51.39,8.26,13.38,17.71,16.13,25.57,5.9,29.9,4.33,26.76-6.69-19.28-9.44-26-8.26-9.83-9.05-6.69.79,4.72,2.75,11.81,2,26,7.87,36.58,28.72,31.23,31.87,39.1S330.9,390,330.9,390",
    style: {
      fill: "#FAA700",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,376s5.9-19.27,5.9-50,5.11-53.11,11.41-62.94,12.19-13.77,14.95-13.77.78,3.54-3.15,8.65-7.47,7.87-9.05,14.16-1.57,14.17.4,13.38,5.11-16.52,7.86-22.42,9.45-13.38,13.38-16.92,12.59-14.16,16.52-11.41,1.58,6.69-.78,8.26-11.81,11-16.13,16.92-7.08,20.85-4.72,21.24,9.44-21.63,13.37-26.36,19.67-17.7,23.21-18.09,3.94,5.11.79,7.87-13.77,14.55-17.31,21.63-5.12,20.07-2,16.92,8.26-16.13,12.59-20.46,17.31-18.09,20.46-16.52,2.36,5.51-.39,8.26-13.38,17.7-16.13,25.57-5.91,29.9-4.33,26.75,6.69-19.27,9.44-26,8.26-9.84,9.05-6.69-.79,4.72-2.76,11.8-2,26-7.86,36.59-28.72,39.34-31.87,47.21-10.23,25.18-10.23,25.18",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.89,376s-5.9-19.27-5.9-50-5.12-53.11-11.41-62.94-12.2-13.77-14.95-13.77-.79,3.54,3.15,8.65,7.47,7.87,9,14.16,1.58,14.17-.39,13.38-5.11-16.52-7.87-22.42-9.44-13.38-13.37-16.92-12.59-14.16-16.53-11.41-1.57,6.69.79,8.26,11.8,11,16.13,16.92,7.08,20.85,4.72,21.24-9.44-21.63-13.37-26.36-19.68-17.7-23.22-18.09-3.93,5.11-.78,7.87,13.77,14.55,17.31,21.63,5.11,20.07,2,16.92-8.26-16.13-12.58-20.46-17.31-18.09-20.46-16.52-2.36,5.51.39,8.26,13.38,17.7,16.13,25.57,5.9,29.9,4.33,26.75-6.69-19.27-9.44-26-8.26-9.84-9.05-6.69.79,4.72,2.75,11.8,2,26,7.87,36.59,28.72,39.34,31.87,47.21,10.23,25.18,10.23,25.18",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.6,436h60c.78-3,1.76-6.36,3-10,4.72-14.14,20-31.82,20-31.82A103.42,103.42,0,0,0,163.84,373c-23-7.08-39.84-5-39.84-5a92.57,92.57,0,0,1,1,39C122,421.56,120,430.77,118.6,436Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.4,436h62.34c-2-5.18-6.32-16.43-10.64-27.68-5.9-15.32-3.54-35.94-5.9-35.94s-28.87-1.77-41.83,2.35-27.7,15.91-27.7,15.91A130.27,130.27,0,0,1,322.76,416,87.71,87.71,0,0,1,329.4,436Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.08,380.2c-.43-1.7-6.83.86-6.83.86s2.14-8.1-1.27-8.1-3.84,6-3.84,6-6.4-2.55-6.4,1.28S142,384,142,384s-5.12,6.4-1.28,7.67,6.39-3.41,6.39-3.41,2.56,4.27,6,2.56.85-5.54.85-5.54S156.5,381.91,156.08,380.2Zm-8.53,6.4a1.75,1.75,0,1,1,2.13-1.71A2,2,0,0,1,147.55,386.6ZM165.46,428c-.43-1.7-6.83.86-6.83.86s2.14-8.1-1.28-8.1-3.83,6-3.83,6-6.4-2.56-6.4,1.27,4.27,3.84,4.27,3.84-5.12,6.4-1.28,7.68,6.39-3.42,6.39-3.42,2.56,4.27,6,2.56.85-5.54.85-5.54S165.88,429.66,165.46,428Zm-8.53,6.4a1.75,1.75,0,1,1,2.13-1.71A1.95,1.95,0,0,1,156.93,434.35Zm-29,0c-.43-1.71-6.82.85-6.82.85s2.13-8.1-1.28-8.1-3.84,6-3.84,6-6.4-2.56-6.4,1.28,4.27,3.84,4.27,3.84-5.12,6.39-1.28,7.67,6.39-3.41,6.39-3.41,2.56,4.26,6,2.56.86-5.54.86-5.54S128.36,436.05,127.94,434.35Zm-8.53,6.39a1.75,1.75,0,1,1,2.13-1.7A1.95,1.95,0,0,1,119.41,440.74Zm55-39.65h4.69c3.41,0,5.54,3.84,5.54,3.84C177.39,407.06,174.41,401.09,174.41,401.09Zm-4.69,33.26h4.69c3.41,0,5.54,3.84,5.54,3.84C172.7,440.32,169.72,434.35,169.72,434.35ZM128.79,428h4.69c3.41,0,5.54,3.84,5.54,3.84C131.77,433.92,128.79,428,128.79,428Zm22.67-30.09,2.74,3.81c2,2.78.11,6.74.11,6.74C148.35,403.77,151.46,397.86,151.46,397.86ZM128,410.65l2.14-4.17c1.57-3,5.95-3.18,5.95-3.18C134.62,410.72,128,410.65,128,410.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.89,388.3c-.43-1.7-6.83.86-6.83.86s2.14-8.1-1.27-8.1-3.84,6-3.84,6-6.4-2.55-6.4,1.28,4.27,3.84,4.27,3.84-5.12,6.4-1.28,7.68,6.39-3.42,6.39-3.42,2.56,4.27,6,2.56.85-5.54.85-5.54S357.31,390,356.89,388.3Zm-8.53,6.4a1.75,1.75,0,1,1,2.13-1.71A1.95,1.95,0,0,1,348.36,394.7Zm28.56,26.86c-.42-1.71-6.82.85-6.82.85s2.13-8.1-1.28-8.1-3.83,6-3.83,6-6.4-2.56-6.4,1.28,4.26,3.84,4.26,3.84-5.11,6.39-1.27,7.67,6.39-3.41,6.39-3.41,2.56,4.26,6,2.56.85-5.54.85-5.54S377.35,423.26,376.92,421.56ZM368.4,428a1.75,1.75,0,1,1,2.13-1.7A1.95,1.95,0,0,1,368.4,428Zm-12.79,6.4c-.43-1.71-6.82.85-6.82.85s2.13-8.1-1.28-8.1-3.84,6-3.84,6-6.4-2.56-6.4,1.28,4.27,3.84,4.27,3.84-5.12,6.39-1.28,7.67,6.39-3.41,6.39-3.41,2.56,4.26,6,2.56.86-5.54.86-5.54S356,436.05,355.61,434.35Zm-8.53,6.39a1.75,1.75,0,1,1,2.13-1.7A1.95,1.95,0,0,1,347.08,440.74Zm28.14-31.55h4.69c3.41,0,5.54,3.84,5.54,3.84C378.2,415.16,375.22,409.19,375.22,409.19ZM324.91,433.5h4.69c3.41,0,5.54,3.83,5.54,3.83C327.89,439.47,324.91,433.5,324.91,433.5ZM352.27,406l2.74,3.81c2,2.78.11,6.74.11,6.74C349.16,411.87,352.27,406,352.27,406ZM380,429.84l2.73,3.81c2,2.77.11,6.74.11,6.74C376.88,435.74,380,429.84,380,429.84Zm-51.23-11.09,2.14-4.17c1.57-3,6-3.18,6-3.18C335.43,418.82,328.76,418.75,328.76,418.75Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.404bccf661238a82b09e64c0f0a3b1f1.svg";
export { ForwardRef as ReactComponent };